export default __webpack_public_path__ + "static/media/pp-rt-bg.3878dc6b.svg";